import { getOrEmptyObject } from '../../utils/selectors'

export const selectEntities = getOrEmptyObject('entities')
